import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

function StoreButton({ icon: Icon, primary, secondary, soon, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={(e) => e.preventDefault()}
      className="group relative flex items-center gap-4 rounded-2xl glass px-6 py-4 min-w-[220px] hover:bg-white/10 transition-colors duration-200"
    >
      <Icon size={28} className="text-white" />
      <div className="text-left rtl:text-right">
        <p className="text-[10px] tracking-[0.2em] uppercase text-zinc-400">{primary}</p>
        <p className="text-base font-medium text-white">{secondary}</p>
      </div>
      <span className="absolute -top-2 -right-2 rtl:-right-auto rtl:-left-2 rounded-full bg-[#E6007E] text-white text-[10px] uppercase tracking-widest px-2 py-1 font-medium">
        {soon}
      </span>
    </button>
  );
}

export default function Download() {
  const { t } = useLanguage();
  return (
    <section id="download" data-testid="download-section" className="relative py-32 md:py-40">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden rounded-[36px] border border-white/10 p-10 md:p-20 text-center"
          style={{
            background:
              "radial-gradient(ellipse at 20% 20%, rgba(230,0,126,0.35), transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(0,166,230,0.35), transparent 60%), #0f0f10",
          }}
        >
          <div className="absolute inset-0 noise-overlay" aria-hidden="true" />

          <p className="text-xs tracking-[0.22em] uppercase text-zinc-300 mb-6 relative">
            {t.download.kicker}
          </p>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-light tracking-tighter text-balance relative">
            {t.download.line1}
            <br />
            <span className="italic">{t.download.line2}</span>
          </h2>
          <p className="mt-6 text-zinc-300 max-w-xl mx-auto relative leading-relaxed">
            {t.download.sub}
          </p>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-4 relative">
            <StoreButton icon={Apple} primary={t.download.comingTo} secondary="App Store" soon={t.download.soon} testId="download-app-store" />
            <StoreButton icon={Play} primary={t.download.comingTo} secondary="Google Play" soon={t.download.soon} testId="download-play-store" />
          </div>

          <p className="mt-8 text-xs text-zinc-500 relative">
            {t.download.foot}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
